import React, { useState, useEffect } from 'react';
import BackRow from 'components/BackRow/BackRow';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import HomeHubItem from './HomeHubItem';
import { post, dodelete, put, get } from 'lib/comms';

const HomeHubItemPage = (props) => {
    const isNew = props.homeHub && props.homeHub.id === 'new';
    const homeHubInit = isNew
        ? {
              id: 'new',
              title: '',
              subtitle: '',
              type: '',
              content: '',
              url: '',
              functionality: '',
              order: 1,
          }
        : props.homeHub;

    const [state, setState] = useState({
        homeHub: homeHubInit,
        editing: [isNew],
        showDeleteDialog: false,
        showMessage: null,
        isNew,
        categoriesKB: [],
    });

    useEffect(() => {
        const getKBCategories = async () => {
            const response = await get(`/content/knowledgebase_categories`, null, true);
            if (response.categories?.length > 0) {
                const categories = response.categories.map((item) => ({
                    name: `KB - ${item.name}`,
                    id: `KBLink_${item.name.toLowerCase().replace(/\s+/g, '-')}`,
                }));
                setState({
                    ...state,
                    categoriesKB: categories,
                });
            }
        };

        getKBCategories();
    }, []);

    const setEditing = async (index) => {
        let { editing, homeHub } = state;
        if (editing[index]) {
            // save to db
            if (!homeHub.title) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid title', title: 'Save Home Hub' },
                });
            }
            if (!homeHub.subtitle) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid subtitle', title: 'Save Home Hub' },
                });
            }

            if (!homeHub.type) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please select a valid type', title: 'Save Home Hub' },
                });
            }

            if (!homeHub.content && homeHub.type === 'content') {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid content', title: 'Save Home Hub' },
                });
            }

            if (homeHub.type === 'url') {
                if (!homeHub.url) {
                    return setState({
                        ...state,
                        showMessage: { message: 'Please include a valid link', title: 'Save Home Hub' },
                    });
                }

                try {
                    new URL(homeHub.url);
                } catch (e) {
                    return setState({
                        ...state,
                        showMessage: {
                            message: 'Please include a properly formatted URL (e.g. https://example.com)',
                            title: 'Save Home Hub',
                        },
                    });
                }
            }

            if (!homeHub.functionality && homeHub.type === 'functionality') {
                return setState({
                    ...state,
                    showMessage: { message: 'Please select a valid functionality', title: 'Save Home Hub' },
                });
            }

            if (!homeHub.order) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please select a valid order', title: 'Save Home Hub' },
                });
            }

            let resp = null;
            if (homeHub.id === 'new') {
                resp = await post('cms/home_hub', homeHub, true);
            } else {
                resp = await put(`cms/home_hub/${homeHub.id}`, homeHub, true);
            }

            if (resp && resp.success && resp.homeHub) {
                props.reload();
                editing[index] = false;
                if (resp.homeHub.id) {
                    editing[1] = true;
                    homeHub.id = resp.homeHub.id;
                    props.updateItemCreated();
                    setState({ ...state, homeHub, isNew: false });
                }
            } else console.log(resp);
            if (resp.message) {
                setTimeout(
                    () => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }),
                    500,
                );
            }
            editing[index] = false;
        } else editing[index] = true;
        setState({ ...state, editing });
    };

    const doDelete = async () => {
        const resp = await dodelete('cms/home_hub', { id: state.homeHub.id }, true);
        if (resp && resp.success && props.onBack) {
            setState({ ...state, homeHub, isNew: false, showDeleteDialog: false });
            props.reload('back');
        } else if (resp.message) {
            setTimeout(() => setState({ showMessage: { message: resp.message, title: 'Delete home hub item' } }), 500);
        }
    };

    let { homeHub, editing } = state;

    return (
        <div className="maincontainer">
            <BackRow
                onBack={props.onBack}
                buttonTitle={state.isNew ? '' : 'DELETE HOME HUB ITEM'}
                onDelete={() => setState({ ...state, showDeleteDialog: true })}
            />

            <HomeHubItem
                homeHub={homeHub}
                editing={editing[0]}
                onToggle={() => setEditing(0)}
                onEdit={(what) => setState({ ...state, homeHub: { ...homeHub, ...what } })}
                categoriesKB={state.categoriesKB}
            />
            {state.showDeleteDialog ? (
                <DeleteDialog
                    item="HomeHub"
                    onSuccess={doDelete}
                    onClose={() => setState({ ...state, showDeleteDialog: false })}
                />
            ) : null}
            {state.showMessage ? (
                <MessageDialog
                    message={state.showMessage.message}
                    title={state.showMessage.title}
                    onClose={() => setState({ ...state, showMessage: null })}
                />
            ) : null}
        </div>
    );
};

export default HomeHubItemPage;
